import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { getAllAddress } from "../../apis/getAllAddress";

export const getAllAddressAction = createAsyncThunk(
  "getAllAddressAction",
  async (customerId: number) => {
    return getAllAddress(customerId, getSessionId()).then((response: any) => {
      return response.data;
    });
  }
);
